// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 846 ? "Flickity" : chunkId) + "." + {"442":"90a3fed1ced4498486b3","846":"2f92c21daff9d0e0d7d1"}[chunkId] + ".js";
};